import sql from '../images/sql.png';
import rails from '../images/rails.png';
import nodejs from '../images/nodejs.png';
import mongodb from '../images/mongodb.png';
import react from '../images/react.png';
import typescript from '../images/typescript.png';
import angular from '../images/angular.png';
import threejs from '../images/threejs.png';

export const Skills = [
  {
    name: 'SQL',
    logo: sql,
    type: 'be',
  },
  {
    name: 'Node JS',
    logo: nodejs,
    type: 'be',
  },
  {
    name: 'Ruby on Rails',
    logo: rails,
    type: 'be',
  },
  {
    name: 'Mongo',
    logo: mongodb,
    type: 'be',
  },
  {
    name: 'React',
    logo: react,
    type: 'fe',
  },
  {
    name: 'Three JS',
    logo: threejs,
    type: 'fe',
  },
  {
    name: 'Angular',
    logo: angular,
    type: 'fe',
  },
  {
    name: 'Typescript',
    logo: typescript,
    type: 'fe',
  },
];
